import { useEffect, useState } from 'react';

// Wrapped text keeps the width it was offered, not the width of its longest
// line, so a block of it cannot sit centred beside an icon. This measures the
// lines whenever the parent resizes and narrows the element to them.
export function useHuggedWidth() {
  const [node, setNode] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const parent = node?.parentElement;
    if (!node || !parent) return;
    const range = document.createRange();
    const hug = () => {
      node.style.width = '';
      range.selectNodeContents(node);
      const lines = [...range.getClientRects()];
      if (lines.length === 0) return;
      const left = Math.min(...lines.map((line) => line.left));
      const right = Math.max(...lines.map((line) => line.right));
      node.style.width = `${Math.ceil(right - left)}px`;
    };
    const observer = new ResizeObserver(hug);
    observer.observe(parent);
    let disposed = false;
    // A width measured in the fallback font would cut the real one short.
    document.fonts?.ready.then(() => {
      if (!disposed) hug();
    });
    return () => {
      disposed = true;
      observer.disconnect();
    };
  }, [node]);

  return setNode;
}
